




























import { appModule } from "@/store/modules/app";
import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {},
})
export default class TekananDarah extends Vue {
  @Prop() setDarah!: object;
  @Prop() setLabel!: string;
  td = "";
  label = "";
  placeholder = this.setLabel;
  validasi = [(v) => this.cek(v) || "*Pastikan Format Benar, contoh: 120/90"];

  handleDelete() {
    const last = this.td.substr(this.td.length - 1);
    if (last == "/") this.td = this.td.substring(0, this.td.length - 1);
  }

  mask() {
    if (Number(this.td) > 99) this.td = this.td + "/";
  }
  mounted() {
    if (this.setLabel == "") {
      this.label = "";
      this.placeholder = "";
    } else {
      if (this.td == "" || this.td == null) {
        this.label = "";
        this.placeholder = this.setLabel;
      } else {
        this.label = this.setLabel;
        this.placeholder = "";
      }
    }
    if (this.setDarah["sistole"] == null && this.setDarah["diastole"] == null) {
      this.td = "";
    } else {
      this.td = this.setDarah["sistole"] + "/" + this.setDarah["diastole"];
    }
  }

  @Watch("td")
  changeTd(val) {
    if (this.setLabel == "") {
      this.label = "";
      this.placeholder = "";
    } else {
      if (val == "" || val == null) {
        this.label = "";
        this.placeholder = this.setLabel;
      } else {
        this.label = this.setLabel;
        this.placeholder = "";
      }
    }

    const tensiArray = val.split("/");
    let tensi = [];

    if (tensiArray.length < 2) {
      tensi[0] = tensiArray[0];
      tensi[1] = "";
    } else {
      tensi = tensiArray;
    }

    this.$emit("td", tensi);
  }

  @Watch("setDarah")
  valDarah(val) {
    if (val["sistole"] == null && val["diastole"] == null) {
      this.td = "";
    } else {
      this.td = val["sistole"] + "/" + val["diastole"];
    }
  }

  cek(val) {
    const darah = val.split("/");
    if (isNaN(darah[0])) this.td = this.td.substring(0, this.td.length - 1);
    if (Number(darah[0]) > 300) {
      appModule.sendErrorAlert(
        "sistole " + Number(darah[0]) + " terlalu tinggi"
      );
      this.td = "";
    }
    if (darah.length == 2) {
      if (isNaN(darah[1])) this.td = this.td.substring(0, this.td.length - 1);
      if (darah[1] == "") {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  }
}
